import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import type { ForwardedRef, ReactNode } from 'react';
import styled from 'styled-components';
import { coreTokens } from '../../core';
import { Tooltip } from '../tooltip';
import { theme } from './dropdown_menu.theme';

type DropdownMenuItemProps = {
	children?: ReactNode;
	disabledText?: string;
} & DropdownMenu.DropdownMenuItemProps;

const elements = {
	item: styled(DropdownMenu.Item)`
		all: unset;
		box-sizing: border-box;
		font: ${theme.getValue('itemFont')};
		color: ${theme.getValue('itemFontColor')};
		border-radius: ${theme.getValue('itemBorderRadius')};
		display: flex;
		align-items: center;
		gap: ${coreTokens.spacing.x1_5};
		width: 100%;
		padding: ${theme.getValue('itemPadding')};
		position: relative;
		user-select: none;
		margin-top: ${coreTokens.spacing.x0_25};
		transition: background 150ms;
		word-break: break-word;
		min-height: ${theme.getValue('itemMinHeight')};
		z-index: 1;

		&:active {
			background: ${theme.getValue('itemActiveBackground')};
		}

		&[data-disabled] {
			opacity: 0.7;
			cursor: not-allowed;
			background: ${theme.getValue('itemDisabledBackground')};
		}

		@media (hover: hover) {
			&[data-highlighted] {
				background: ${theme.getValue('itemHoverBackground')};
			}
		}
	`,
};

export function CellulaDropdownMenuItem(
	{ disabledText, children, ...rest }: DropdownMenuItemProps,
	ref: ForwardedRef<HTMLDivElement>,
): JSX.Element {
	const item = (
		<elements.item {...rest} ref={ref}>
			{children}
		</elements.item>
	);

	return <>{disabledText ? <Tooltip content={disabledText ?? ''}>{item}</Tooltip> : item}</>;
}
